import Calendar from "@/components/Calendar/Calendar.vue";
import CalendarHeader from "@/components/Calendar/CalendarHeader.vue";

// CALENDAR TO SHOW TASKS / TIME / ETC... 

export default [
    {
        path: "calendar/reset",
        name: "CalendarReset",
        components: {
            page: Calendar,
            header: CalendarHeader
        },
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "calendar",
        name: "Calendar",
        components: {
            page: Calendar,
            header: CalendarHeader
        },
        meta: {
            requiresAuth: true
        }
    }
];